import { apyToAprPercent } from '../../../utils/parsing'
import { YieldFetcher } from '../../types'
import { fetchDefiLlamaApy } from './defillama'

/**
 * Liquid Collective lsETH — intrinsic liquid-staking APR.
 *
 * Sourced from DefiLlama's `liquid-collective` pool (Ethereum). DefiLlama
 * reports a compounded APY → converted to APR (pipeline convention).
 * Emitted under every assetGroup the token-lists classifier assigns lsETH
 * across chains (bridged deployments vary the display name).
 */
const LSETH_POOL_ID = '465d177e-3d0d-42c0-b5f5-31c857567135'

const KEYS = ['Liquid Staked ETH::LSETH', 'LSETH']

export const lsethFetcher: YieldFetcher = {
  label: 'LSETH',
  fetch: async () => {
    const apr = apyToAprPercent(await fetchDefiLlamaApy(LSETH_POOL_ID))
    return Object.fromEntries(KEYS.map((k) => [k, apr]))
  },
}
